import { useTileDataContext } from '~/contexts/TileDataContext';

export default function YearMakeModel() {
  const {
    tileData: { make, model, year }
  } = useTileDataContext();

  return (
    <p className="font-bold text-[18px] truncate" data-qa="make-model">
      {year} {make} {model}
    </p>
  );
}
